import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { AttributeOption } from '~shared/models';
import { NUMBER_0, NUMBER_25, NUMBER_6 } from '~shared/constants';

@Component({
  selector: 'app-brand-names',
  templateUrl: './brand-names.component.html',
  styleUrls: ['./brand-names.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandNamesComponent {
  @Input() brands: Array<AttributeOption>;
  @Input() isMobile: boolean;
  @Input() getBrandPath: (brandSlug: string) => string;
  @Output() onBrandClickGAEvent = new EventEmitter<string>();

  readonly NUMBER_0: number = NUMBER_0;

  get limit(): number {
    return this.isMobile ? NUMBER_6 : this.brands.length;
  }

  onBrandClick(brandSlug: string): void {
    this.onBrandClickGAEvent.emit(brandSlug);
  }

  protected readonly NUMBER_25 = NUMBER_25;
}
